/**
 * Client for the ai_assistant gateway's user-scoped chat history endpoints (`/conversations`,
 * `/conversations/:id`). Same transport pattern as assistantAdmin.service.js: a separate host from
 * the www API, called with `fetch` + `credentials:include` so the gateway can resolve the session
 * cookie itself. Unlike the admin endpoints, these are scoped server-side to the caller's own
 * conversations — no admin flag required.
 */

function baseUrl() {
  if (process.env.VUE_APP_ASSISTANT_URL) {
    return process.env.VUE_APP_ASSISTANT_URL.replace(/\/$/, '')
  }
  if (process.env.VUE_APP_ASSISTANT_WS) {
    try {
      const u = new URL(process.env.VUE_APP_ASSISTANT_WS)
      const scheme = u.protocol === 'wss:' ? 'https:' : 'http:'
      return `${scheme}//${u.host}`
    } catch (e) { /* fall through */ }
  }
  try {
    const u = new URL(process.env.VUE_APP_SERVER)
    const scheme = u.protocol === 'https:' ? 'https:' : 'http:'
    return `${scheme}//${u.hostname}:3200`
  } catch (e) {
    return 'http://localhost:3200'
  }
}

async function get(path, params) {
  const url = new URL(baseUrl() + path)
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') url.searchParams.set(k, v)
    })
  }
  const res = await fetch(url.toString(), {
    method: 'GET',
    credentials: 'include',
    headers: { Accept: 'application/json' },
  })
  if (!res.ok) {
    const err = new Error(`Assistant request failed: ${res.status}`)
    err.status = res.status
    throw err
  }
  return res.json()
}

export default {
  conversations,
  conversation,
}

function conversations(limit) {
  return get('/conversations', limit ? { limit } : undefined)
}

function conversation(id) {
  return get(`/conversations/${encodeURIComponent(id)}`)
}
